export default "__VITE_ASSET__CCJXHFw3__"